import React, { useCallback, useMemo, useState } from 'react'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'
import { ButtonIcon } from '../Button/Button'
import Portal, { PortalType, SlotPortal } from '../Portal'

const MobileMenu: React.FC = ({ children }) => {
  const [open, setOpen] = useState(false)

  const dynStyle = useMemo<React.CSSProperties | undefined>(
    () => ({
      left: open ? 0 : undefined,
    }),
    [open]
  )

  const toggleMenu = useCallback(() => {
    setOpen(!open)
  }, [open, setOpen])

  return (
    <div
      className={classNames([styles.Menu, styles.MenuLeft, styles.SideMenuA])}
      style={dynStyle}>
      <div className={styles.Content}>
        <SlotPortal name={PortalType.Burger}>
          <ButtonIcon
            onClick={toggleMenu}
            additionalClassNames={[styles.IconMenu, styles.ShowMenu]}
            title={'Toggle Menu'}
          />
        </SlotPortal>
        <ButtonIcon
          title='Close'
          onClick={toggleMenu}
          additionalClassNames={[styles.IconClose, styles.MenuClose]}
        />
        {children}
        {open && (
          <Portal>
            <div
              onClick={toggleMenu}
              style={{ display: 'block' }}
              className={classNames([styles.ButtonCover, styles.CoverDark])}
            />
          </Portal>
        )}
      </div>
    </div>
  )
}

export default MobileMenu
